var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-full flex flex-wrap" },
    [
      _vm.$store.state.jwt
        ? _c(
            "aside",
            {
              staticClass:
                "bg-secondary w-full md_w-3-12 xl_w-2-12 md_min-h-screen overflow-hidden"
            },
            [
              _c(
                "div",
                {
                  staticClass: "px-1_5",
                  style: {
                    height: ["xs", "sm", "md"].includes(_vm.$mq)
                      ? _vm.menuHeight + "px"
                      : "auto"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      ref: "logo",
                      staticClass: "flex items-center py-_5 md_py-1_5"
                    },
                    [
                      _c("div", {
                        staticClass:
                          "w-2-12 mdi text-3xl text-secondary-200 md_hidden",
                        class: _vm.menuOpen ? "mdi-close" : "mdi-menu",
                        on: { click: _vm.clickMenuIcon }
                      }),
                      _c(
                        "svg",
                        {
                          staticClass: "h-2 lg_h-3 w-8-12 md_w-full",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 365.5 102.2"
                          }
                        },
                        [
                          _c("path", {
                            staticClass: "fill-current text-white",
                            attrs: {
                              d:
                                "M261.5 102.2c2.4-5.7 4.6-11 6.8-16.3.3-.8.3-1.8 0-2.6-3.9-10-7.9-20.1-11.8-30.1-.4-1.2-.9-1.7-2.2-1.6-1.9.1-3.7 0-5.9 0v35.2h-13.8V51.6H228V41.1h6.5V25.9h13.8V41h14c4.3 0 4.3 0 5.7 4.1l7.2 20.7c.1.4.3.8.7 1.6 2.3-7 4.5-13.6 6.7-20.1.7-2.1.9-4.9 2.4-6 1.4-1 4.1-.3 6.3-.3h8.1c-1.2 3.2-2.3 6.2-3.5 9.2-6.3 16.7-12.6 33.3-18.9 50-.5 1.4-1.1 2-2.7 1.9-4.1 0-8.3.1-12.8.1z"
                            }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-primary",
                            attrs: {
                              d:
                                "M153.4 86.7v-4.4c-7 8.9-21.2 6.9-28.1 1.2-11.5-9.5-11.8-31.3 1.7-40.1 5.5-3.6 11.5-4.8 18-3.2 3.3.8 6 2.6 8.3 5.7v-4.7H167v45.5h-13.6zM142 75.6c6.5 0 11.4-5 11.4-11.7 0-6.6-5-11.6-11.5-11.6-6.4 0-11.4 5.1-11.4 11.8.1 6.5 5.2 11.5 11.5 11.5z"
                            }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-white",
                            attrs: {
                              d:
                                "M365.1 68.2H331c.6 6.5 7.1 9 11.5 8.5 2.6-.3 4.7-1.4 6.4-3.3.4-.4 1.1-.9 1.6-.9 4-.1 7.9 0 11.9 0 .4 0 .8.1 1.2.1C361 81.1 350.3 90.7 337 88c-13.9-2.8-21.2-15.3-19.7-26.8C319.2 46.9 332 37.3 346 40c12.9 2.4 21.5 15 19.1 28.2zm-13.6-9.5c-.8-4.5-5.2-7.6-10.4-7.5-5 .1-9.1 3.2-9.8 7.5h20.2z"
                            }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-primary",
                            attrs: {
                              d:
                                "M23.9 40.2l15.9 15c.5.5.8 1.4 1.1 2.1 2 6 4.1 12 5.7 16.8 5-17.4 10.3-35.8 15.6-54.5 5.5 2 10.8 3.9 16.4 5.8 2-5 3.9-9.8 5.9-14.9-5-2.4-9.8-5-14.6-7.5 0-.1.1-.3.1-.4C78 5 86 7.4 94.3 9.9c-3.7 8.5-7.3 16.9-11.1 25.4-3.9-1.1-7.7-2.1-11.7-3.2-.3.8-.5 1.5-.8 2.2-5.6 17-11.2 33.9-16.7 50.8-.5 1.5-1.2 1.9-2.7 1.9-3.3-.1-6.6 0-9.8-.1-.6 0-1.6-.5-1.8-1C34.3 70.8 29 55.6 23.6 40.5l.3-.3z"
                            }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-white",
                            attrs: {
                              d:
                                "M191.6 73.2c4.4 0 8.6 0 12.7.1.5 0 1.2.7 1.4 1.2 1.3 3.6 6.9 3.4 8.7 1.5 1.3-1.4 1.3-3.3-.3-4.6-1.2-.9-2.6-1.6-4-2.1-2.6-1-5.2-1.9-7.9-2.9-.7-.3-1.5-.6-2.2-.9-10.8-5-9.1-16-2.8-21.4 7.5-6.4 20.4-5.9 26.9 1.1 2 2.2 3 4.6 3.6 8.9h-12.8c-.3 0-.7-.6-.9-1-1.2-2.4-4.8-3.1-6.8-1.4-1.5 1.3-1.5 3.3.4 4.4 2 1.2 4.3 2 6.6 2.8 2.6 1 5.3 1.7 7.9 2.8 8.8 3.8 8.7 14.1 4.7 19.5-4.7 6.4-11.5 7.9-18.9 7.2-4.5-.4-8.7-2-11.9-5.5-2.7-2.7-3.8-5.9-4.4-9.7zM39.8 49c-.9-.8-1.3-1.2-1.8-1.6-4.6-4.3-9.3-8.5-13.9-12.8-1-.9-1.8-1.1-3-.7-3.3 1-6.5 1.9-10.1 2.8-3.6-8.3-7.2-16.5-11-24.9.9-.4 1.7-.8 2.5-1.2C9.8 7.4 17 4.2 24.3 1.1c1.5-.6 3.2-.9 4.8-1 3.3-.2 6.6 0 10 0 .8 5.1 2.6 9.6 8.6 10 4.2.3 7.5-2.6 9.5-7.8 1.1 5.3-2.6 11.1-7.8 13-6.8 2.5-13.6.2-16.5-5.8-3-.3-5.8 0-8.5 1.4-4 2-8.3 3.7-12.5 5.6 1.1 2.9 2.2 5.7 3.4 8.4.2.4 1.3.8 1.8.7 4.3-1.1 8.7-2.3 13-3.6 1.5-.4 2.1-.3 2.5 1.3 2.2 8 4.5 16 6.8 24 .2.4.2.8.4 1.7z"
                            }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-primary",
                            attrs: { d: "M172.9 26h13.4v60.8h-13.4V26z" }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-white",
                            attrs: { d: "M313.8 86.8h-13.5V25.9h13.5v60.9z" }
                          }),
                          _c("path", {
                            staticClass: "fill-current text-primary",
                            attrs: {
                              d:
                                "M93.1 86.8V41.2h12.8v4c2.9-4.1 6.8-5.6 11.7-5.6 0 4.4 0 8.7-.1 12.9 0 .3-.8.8-1.2.9-1.2.2-2.4.2-3.6.5-4 .8-5.9 3.1-5.9 7.1-.1 7.8 0 15.7 0 23.5v2.3H93.1zM87.5 86.9H75.3c-.4 0-.8 0-1.3-.1V41.3h13.5v45.6z"
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _c(
                    "b-menu",
                    {
                      ref: "menu",
                      staticClass: "md_mt-1 menu pb-_5 md_pb-1_5",
                      attrs: { activable: false }
                    },
                    [
                      _c(
                        "b-menu-list",
                        { attrs: { label: "Menu" } },
                        [
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "customer",
                                "customers"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "account-group-outline",
                              label: "Customers",
                              tag: "router-link",
                              to: "/admin/customers/1"
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "invoice",
                                "invoices"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "receipt",
                              label: "Invoices",
                              tag: "router-link",
                              to: "/admin/invoices/1"
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "order",
                                "orders",
                                "order-details",
                                "order-printer-jobs"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "cart-outline",
                              label: "Orders",
                              tag: "router-link",
                              to: "/admin/orders/1"
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "products",
                                "product-create",
                                "product-edit"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "tshirt-crew-outline",
                              label: "Products",
                              tag: "router-link",
                              to: { name: "products", params: { page: "1" } }
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "printers",
                                "printer",
                                "printer-edit",
                                "printer-product-edit"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "printer",
                              label: "Printers",
                              tag: "router-link",
                              to: { name: "printers", params: { page: "1" } }
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "printer-jobs",
                                "printer-job"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "tray-full",
                              label: "Printer Jobs",
                              tag: "router-link",
                              to: "/admin/printer-jobs/1"
                            }
                          }),
                          _c("b-menu-item", {
                            class: {
                              "router-link-exact-active": [
                                "rule-create",
                                "rule-edit"
                              ].includes(_vm.$route.name)
                            },
                            attrs: {
                              icon: "wrench-outline",
                              label: "Rule Builder",
                              tag: "router-link",
                              to: "/admin/rules/1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "b-menu-list",
                        { attrs: { label: "Actions" } },
                        [
                          _c("b-menu-item", {
                            attrs: { icon: "logout", label: "Sign Out" },
                            on: { click: _vm.logout }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "min-h-full w-full md_w-9-12 xl_w-10-12" },
        [
          _c(
            "div",
            {
              staticClass:
                "bg-white dark-mode_bg-secondary w-full flex items-center border-b border-gray-300 md_border-l dark-mode_border-secondary-1000 border-t md_border-t-0"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "text-xl dark-mode_text-secondary-600 capitalize px-1_5 py-_5 md_p-1 border-r dark-mode_border-secondary-1000 border-gray-300"
                },
                [
                  ["order-details", "order", "order-printer-jobs"].includes(
                    _vm.$route.name
                  )
                    ? _c("span", [_vm._v("Order")])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$route.name
                              ? _vm.$route.name.replaceAll("-", " ")
                              : ""
                          )
                        )
                      ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex flex-wrap text-secondary-600 text-sm px-1"
                },
                [
                  ["customer"].includes(_vm.$route.name)
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/customers/1" } },
                          [_vm._v("CUSTOMERS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("CUSTOMER # " + _vm._s(_vm.$route.params.id))]
                        )
                      ]
                    : _vm._e(),
                  ["invoice"].includes(_vm.$route.name)
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/invoices/1" } },
                          [_vm._v("INVOICES")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("INVOICE # " + _vm._s(_vm.$route.params.id))]
                        )
                      ]
                    : _vm._e(),
                  ["order-details", "order", "order-printer-jobs"].includes(
                    _vm.$route.name
                  )
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/orders/1" } },
                          [_vm._v("ORDERS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("ORDER # " + _vm._s(_vm.$route.params.id))]
                        )
                      ]
                    : _vm.$route.name === "rule-edit"
                    ? [
                        _c("router-link", { attrs: { to: "/admin/rules/1" } }, [
                          _vm._v("RULES")
                        ]),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("RULE # " + _vm._s(_vm.$route.params.id))]
                        )
                      ]
                    : _vm.$route.name === "rule-create"
                    ? [
                        _c("router-link", { attrs: { to: "/admin/rules/1" } }, [
                          _vm._v("RULES")
                        ]),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("CREATE RULE")]
                        )
                      ]
                    : _vm.$route.name === "product-edit"
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/products/1" } },
                          [_vm._v("PRODUCTS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c("span", { staticClass: "text-secondary-200" }, [
                          _vm._v("PRODUCT # " + _vm._s(_vm.$route.params.id))
                        ])
                      ]
                    : _vm.$route.name === "product-create"
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/products/1" } },
                          [_vm._v("PRODUCTS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [_vm._v("CREATE PRODUCT")]
                        )
                      ]
                    : [
                        "printer",
                        "printer-edit",
                        "printer-product-edit"
                      ].includes(_vm.$route.name)
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/printers/1" } },
                          [_vm._v("PRINTERS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _vm.$route.name === "printer-product-edit"
                          ? [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/admin/printer/" +
                                      _vm.$route.params.printerId
                                  }
                                },
                                [
                                  _vm._v(
                                    "PRINTER # " +
                                      _vm._s(_vm.$route.params.printerId)
                                  )
                                ]
                              ),
                              _c("span", [_vm._v("  /  ")]),
                              _c(
                                "span",
                                { staticClass: "dark-mode_text-secondary-200" },
                                [
                                  _vm._v(
                                    "PRODUCT # " + _vm._s(_vm.$route.params.id)
                                  )
                                ]
                              )
                            ]
                          : _c(
                              "span",
                              { staticClass: "dark-mode_text-secondary-200" },
                              [
                                _vm._v(
                                  "PRINTER # " + _vm._s(_vm.$route.params.id)
                                )
                              ]
                            )
                      ]
                    : ["printer-job"].includes(_vm.$route.name)
                    ? [
                        _c(
                          "router-link",
                          { attrs: { to: "/admin/printer-jobs/1" } },
                          [_vm._v("PRINTER JOBS")]
                        ),
                        _c("span", [_vm._v("  /  ")]),
                        _c(
                          "span",
                          { staticClass: "dark-mode_text-secondary-200" },
                          [
                            _vm._v(
                              "PRINTER JOB # " + _vm._s(_vm.$route.params.id)
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm.$store.state.user ? _c("router-view") : _vm._e()
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "account" } },
        [!_vm.$store.state.jwt ? _c("account") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }